export const GET_ONSTREET_LOCATIONS = 'GET_ONSTREET_LOCATIONS'
export const SET_ONSTREET_LOCATIONS = 'SET_ONSTREET_LOCATIONS'
